var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDriveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2L26 10H18L14.5 2Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10L18 22H10L18 10H26Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22L2 10H10L18 22H10Z",
    fill: "#00832D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10L14.5 2L10 10H2Z",
    fill: "#2684FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L14.5 2L18 10H10Z",
    fill: "#00AC47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10L14.5 2L22 10H18Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveIcon);
export default __webpack_public_path__ + "static/media/google-drive-icon.496c51c08435fc277f6a8bd012d3acd0.svg";
export { ForwardRef as ReactComponent };